var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgValeu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 567.45 417.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff0;}.cls-2{fill:#fff;}.cls-3{fill:#002c4d;}.cls-4{fill:#ffbc96;}.cls-5{fill:#002443;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M242.35,45.53C240,23.24,258.46,3,283.66.3s47.54,13.2,49.92,35.5S317.46,78.34,292.27,81a51.59,51.59,0,0,1-5.24.29l1.09,10.23c.32,3.06-2.69,4.65-4.38,2.3L273.48,79.57C256.8,75,244.11,62,242.35,45.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M198.16,79.57c-17.09,6-35.62,13.31-49,25.85-6.21,5.8-12.11,13-13.62,21.63-2.08,11.93,6.44,23,3.75,34.84-3.52,15.44-24.33,22.48-33.71,34-6.83,8.4-11.2,19.46-9.14,30.08,2.19,11.35,11,20,18.41,28.87,26.8,32-4.11,46.06-14.38,75.3-8,22.75,10.62,44.88,29.63,55.06,43.37,23.24,102.09,25.46,150.2,27.74,70.34,3.33,142.33-2.47,210-22.65,28.54-8.52,69.72-17.89,76.48-52.51,3.43-17.55-5.58-36-19.53-47.17-22-17.68-50.9-18.53-77.84-18.53-24,0-54.13,2.86-48.55-31.74,4-25,23.8-45.4,27.13-70.48a57,57,0,0,0-18.84-49.7c-34.58-29.95-65.06.92-100.94,6.4C306,130,298.36,108.09,286.81,94.28c-15.08-18-40.12-23.69-63.12-20.8A125.87,125.87,0,0,0,198.16,79.57Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 289.32,
    cy: 293.43,
    r: 73.11,
    transform: "translate(-109.43 189.46) rotate(-30.79)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 266.45,
    cy: 332.3,
    r: 44.06,
    transform: "translate(-96.73 554.84) rotate(-82.77)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 376.28,
    cy: 257.48,
    r: 50.96,
    transform: "translate(6.48 524.2) rotate(-70.18)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 404.93,
    cy: 326.46,
    r: 50.96,
    transform: "translate(-103.4 436.64) rotate(-51.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M410.15,373.56A52.41,52.41,0,1,1,457,344.87h0A52.47,52.47,0,0,1,410.15,373.56Zm.17-101.91A49.51,49.51,0,1,0,432.64,277,49.57,49.57,0,0,0,410.32,271.65Zm45.36,72.56h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M397.15,260.63a28.31,28.31,0,1,1,25.29-15.5h0A28.33,28.33,0,0,1,397.15,260.63Zm.08-53.73a25.67,25.67,0,0,0-7.92,1.27,25.19,25.19,0,1,0,7.92-1.27Zm23.92,37.57h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 328.41,
    cy: 192.87,
    r: 68.35,
    transform: "translate(-40.19 288.71) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M410,414H139.49l50.32-107.66a39.38,39.38,0,0,1,51.83-19.24l34.87,15.7,92.32-10.41A42.44,42.44,0,0,1,415.9,337.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M264.63,266.9l24.29,5.89A52.39,52.39,0,0,0,352,234.36l2.33-9.63a65.6,65.6,0,0,0-48.13-79l-5,9A41.11,41.11,0,0,0,251.7,184.9l-10.55,43.46A32,32,0,0,0,264.63,266.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M337.45,302.63l-17.92-.79-20.08-89.25-64,13.73,13.4,72.41s4,39.17,34.13,39.17,54.55-14.86,54.55-33.2A20.19,20.19,0,0,0,337.45,302.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M283,339.35c-31.07,0-35.53-40.06-35.57-40.47l-13.39-72.3a1.45,1.45,0,0,1,1.13-1.68l64-13.72a1.45,1.45,0,0,1,1.72,1.1l19.83,88.16,16.82.74a1.45,1.45,0,0,1,1.38,1.3c.08.84.12,1.54.12,2.22C339,323.81,313.9,339.35,283,339.35ZM237.17,227.44l13.15,71c.05.49,4.25,38,32.7,38,29.28,0,53.1-14.24,53.1-31.75,0-.22,0-.45,0-.68l-16.63-.73a1.46,1.46,0,0,1-1.36-1.13l-19.76-87.85Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 313,
    cy: 168.18,
    r: 24.71,
    transform: "translate(-38.63 219.23) rotate(-36.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M311.5,154.92A55.63,55.63,0,0,1,346.11,218a38.39,38.39,0,0,1-22.17,1.17C304,214.33,291.52,195,296.13,176A34.37,34.37,0,0,1,311.5,154.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M342.34,192.36a55.63,55.63,0,0,1-27.45,66.52,38.27,38.27,0,0,1-14.8-16.54c-8.75-18.59-1.5-40.42,16.2-48.74A34.38,34.38,0,0,1,342.34,192.36Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 296.61,
    cy: 168.87,
    r: 24.71,
    transform: "translate(-44.38 183.68) rotate(-32.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M244.31,157.45A25.41,25.41,0,1,0,275,138.74,25.41,25.41,0,0,0,244.31,157.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M272.2,153.8a25.41,25.41,0,1,0,30.69-18.7A25.42,25.42,0,0,0,272.2,153.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M358.55,193.21a1.4,1.4,0,0,1-.76-.22h0c-.08,0-7.25-4.39-13.3-.73a1.46,1.46,0,1,1-1.51-2.49c7.6-4.59,16,.54,16.34.76a1.45,1.45,0,0,1-.77,2.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M345.57,191.54a13.61,13.61,0,0,1-2.42-.22,1.46,1.46,0,1,1,.54-2.86c6.95,1.31,12.14-5.28,12.19-5.35a1.45,1.45,0,0,1,2.3,1.77C358,185.18,353,191.54,345.57,191.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M233.78,185.26c19.34-30.67,56-42.29,81.91-26,21.89,13.81,29.07,43.17,19.09,70.45.6.14,1.2.29,1.81.49a19.25,19.25,0,0,1-10.76,36.92,19.12,19.12,0,0,1-11-7.4c-20.18,18.71-48.21,23.82-69.18,10.59C219.76,254,214.45,215.93,233.78,185.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M271.88,279.25a50.25,50.25,0,0,1-27-7.67c-26.54-16.73-32.07-55.8-12.33-87.09,9.53-15.12,23.48-26.21,39.28-31.22s31.73-3.32,44.62,4.81c21.67,13.66,29.86,42.55,20.21,70.67l.39.12a20.94,20.94,0,0,1,13.53,24,20.65,20.65,0,0,1-35.93,9C301.83,273.3,286.55,279.25,271.88,279.25Zm17.73-125.91a56.13,56.13,0,0,0-16.9,2.7c-15.14,4.8-28.53,15.45-37.7,30-18.88,29.94-13.76,67.22,11.42,83.1,20,12.61,47.09,8.42,67.42-10.43a1.48,1.48,0,0,1,1.13-.38,1.43,1.43,0,0,1,1,.59,17.76,17.76,0,0,0,31.74-6.67,18,18,0,0,0-11.63-20.62c-.56-.19-1.12-.33-1.68-.46a1.49,1.49,0,0,1-.94-.72,1.46,1.46,0,0,1-.09-1.19c10-27.29,2.39-55.55-18.5-68.72A47,47,0,0,0,289.61,153.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M286.18,196.12c-1.81,1.83-4.23,2.38-5.4,1.23s-.64-3.57,1.17-5.41,4.23-2.38,5.39-1.23S288,194.28,286.18,196.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M259.83,180.31c-1.81,1.83-4.23,2.38-5.4,1.23s-.64-3.57,1.17-5.41,4.23-2.38,5.39-1.23S261.64,178.47,259.83,180.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M300.12,189.41a1.45,1.45,0,0,1-1.43-1.21c-1.05-6.1-7.59-8.87-7.66-8.9a1.44,1.44,0,0,1-.78-1.89,1.45,1.45,0,0,1,1.9-.79c.32.14,8.09,3.43,9.4,11.09a1.47,1.47,0,0,1-1.19,1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M268.48,238.5c-5.29,0-9.76-3.43-13-10a44,44,0,0,1-3.57-11,1.48,1.48,0,0,1,.53-1.37,1.46,1.46,0,0,1,1.45-.21c6.84,2.78,23-2.42,23.14-2.48a1.46,1.46,0,0,1,1.12.1,1.42,1.42,0,0,1,.72.87c.15.49,3.59,12.26-.82,19.2a10.45,10.45,0,0,1-7.64,4.74A13.72,13.72,0,0,1,268.48,238.5Zm-13.24-19.19c1.31,5.23,5.39,17.56,14.72,16.18a7.55,7.55,0,0,0,5.61-3.43c2.91-4.57,1.58-12.24.85-15.39C272.56,217.8,262.13,220.55,255.24,219.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M330.56,204.09l-20.23,32.27a3.76,3.76,0,0,0-.31,3.39h0a3.77,3.77,0,0,0,5.47,1.84l19.41-11.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M323.2,247.64a1.45,1.45,0,0,1-1.3-2.08c.15-.31,3.79-7.68,11.31-8.53a1.45,1.45,0,0,1,.32,2.89c-5.91.66-9,6.84-9,6.9A1.45,1.45,0,0,1,323.2,247.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M349.77,181.27a65,65,0,0,1,4.56,43.46L352.58,232a25.4,25.4,0,1,1-2.81-50.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M261.32,198.42a1.45,1.45,0,0,1-1.17-2.31c8.23-11.18,11.2-20.19,8.6-26.06-2.82-6.38-11.35-7.33-11.44-7.34a1.45,1.45,0,0,1-1.29-1.59,1.44,1.44,0,0,1,1.59-1.3c.42.05,10.3,1.15,13.8,9.06,3.08,7,.08,16.71-8.92,29A1.43,1.43,0,0,1,261.32,198.42Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 325.33,
    y: 394.73,
    width: 40.74,
    height: 2.9,
    transform: "matrix(0.26, -0.97, 0.97, 0.26, -126.46, 627.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M371.77,210.52c.46-25.35-13.81-50-38.88-62.2a73.08,73.08,0,0,0-41-6.87c-.46,25.36,13.81,50,38.88,62.2A73.08,73.08,0,0,0,371.77,210.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M200.6,415.75V330.41l1.49-28.21A48.68,48.68,0,0,0,190,267.45l-24.08-27.37a7.92,7.92,0,0,0-8.56-2.26h0a7.93,7.93,0,0,0-4.27,11.43l12.65,22.11-34,9.29L92,265a8.08,8.08,0,0,0-9.89,3.37h0a4.29,4.29,0,0,0,1.63,6l71.3,39L127.91,415.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M127.91,417.2a1.65,1.65,0,0,1-.38-.05,1.46,1.46,0,0,1-1-1.77L153.3,314,83,275.59a5.73,5.73,0,0,1-2.17-8,9.48,9.48,0,0,1,11.66-4l39.33,15.5,31.76-8.68L151.85,250A9.38,9.38,0,0,1,167,239.12l24.08,27.37a49.85,49.85,0,0,1,12.43,35.78l-1.49,28.21v85.27a1.45,1.45,0,1,1-2.9,0V330.41l1.49-28.29a47,47,0,0,0-11.71-33.71L164.85,241a6.48,6.48,0,0,0-10.49,7.49L167,270.64a1.45,1.45,0,0,1-.88,2.12l-34,9.29a1.38,1.38,0,0,1-.92-.05L91.42,266.33a6.6,6.6,0,0,0-8.11,2.76,2.83,2.83,0,0,0,1.07,4l71.31,39a1.45,1.45,0,0,1,.71,1.64L129.31,416.12A1.45,1.45,0,0,1,127.91,417.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M113.57,281.61l-15.33-26.9a3.51,3.51,0,0,1,3.42-5.23h0a13,13,0,0,1,9.09,5.22l18.8,24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M113.57,283.06a1.45,1.45,0,0,1-1.26-.73L97,255.43a5,5,0,0,1,4.84-7.39,14.51,14.51,0,0,1,10.1,5.8l18.77,24a1.45,1.45,0,1,1-2.29,1.79l-18.79-24a11.63,11.63,0,0,0-8.1-4.68,2.06,2.06,0,0,0-2,3.07l15.33,26.91a1.43,1.43,0,0,1-.54,2A1.41,1.41,0,0,1,113.57,283.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M167.24,296.84l-23.41-12.41L131,258.13a11.33,11.33,0,0,0-9.24-6.33h0a3.62,3.62,0,0,0-3.75,4.72l11,34.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M167.24,298.29a1.4,1.4,0,0,1-.68-.17l-23.41-12.41a1.4,1.4,0,0,1-.62-.65l-12.8-26.3a9.89,9.89,0,0,0-8-5.51,2.12,2.12,0,0,0-1.88.81,2.16,2.16,0,0,0-.37,2l11,34.17a1.45,1.45,0,1,1-2.76.89l-11-34.17a5.08,5.08,0,0,1,5.25-6.61,12.81,12.81,0,0,1,10.42,7.13l12.59,25.88,23,12.19a1.45,1.45,0,0,1-.68,2.73Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 350.04,
    cy: 303.03,
    r: 44.01,
    transform: "translate(-111.75 336.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M361.11,248.41l-9-28.94a5,5,0,0,0-7.95-2.28,13.5,13.5,0,0,0-4.63,11.8l1.37,11.89-3.23,3.37,1.5-14.75a1.56,1.56,0,0,0,0-.57l-6.41-23.8a4.71,4.71,0,0,0-6.79-2.91,12.08,12.08,0,0,0-5.92,7.49l-.21.77-5.28-11a1.58,1.58,0,0,0-1.8-.85,11.43,11.43,0,0,0-8,8.62,3.74,3.74,0,0,0-1.33-.4,3.63,3.63,0,0,0-3.33,1.52,16.55,16.55,0,0,0-2.53,13.94l3,11.37-5.92,22.49-26.19,13.46a43,43,0,0,0-22,27.69L217.52,414c-.12.48,0-.39.31,0s.75,0,1.23,0h65.21c.77,0,1.4.76,1.51,0l15.43-113.69,59.41-50.18A1.59,1.59,0,0,0,361.11,248.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M284.21,415.42H284a1.46,1.46,0,0,1-1.25-1.64l15.52-114.51a1.37,1.37,0,0,1,.5-.91l59.14-50-8.74-28a1.91,1.91,0,0,0-3.07-.88,10.42,10.42,0,0,0-3.59,9.14L344,241.27a1.47,1.47,0,0,1-.39,1.17l-7.14,7.45a1.45,1.45,0,0,1-2.1-2l6.67-6.95-1.37-12a13.35,13.35,0,0,1,4.58-11.68,4.82,4.82,0,0,1,7.73,2.22l9,28.94a1.46,1.46,0,0,1-.45,1.54L301.09,300.2l-15.44,114A1.45,1.45,0,0,1,284.21,415.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M334.47,261.2h-.15A1.45,1.45,0,0,1,333,259.6l3.07-30.14-6.34-23.54a1.68,1.68,0,0,0-1-1.1,1.64,1.64,0,0,0-1.45.07,9.08,9.08,0,0,0-4.44,5.61l-1,3.7a1.45,1.45,0,1,1-2.8-.75l1-3.7a12,12,0,0,1,5.85-7.42,4.58,4.58,0,0,1,6.6,2.83L339,229a1.57,1.57,0,0,1,0,.53l-3.11,30.4A1.44,1.44,0,0,1,334.47,261.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M323.61,262.75l-.21,0a1.44,1.44,0,0,1-1.22-1.64l4.28-29.66L312.33,202c-1.84.88-5.36,3.42-4.95,9.88a1.45,1.45,0,0,1-2.9.18c-.69-11,8.16-13.27,8.25-13.29a1.42,1.42,0,0,1,1.64.78l14.89,31a1.43,1.43,0,0,1,.13.84l-4.34,30.09A1.46,1.46,0,0,1,323.61,262.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M219.06,415.42a1.44,1.44,0,0,1-1.41-1.8l28.94-116.25a42.83,42.83,0,0,1,21.94-27.61l26.23-13.49,5.94-22.58-3-11.4a16.41,16.41,0,0,1,2.51-13.83,3.55,3.55,0,0,1,6.1.56l12.13,25.91a1.39,1.39,0,0,1,.12.85l-4.34,26.68a1.45,1.45,0,1,1-2.87-.47l4.27-26.24-11.94-25.5a.61.61,0,0,0-.52-.37.63.63,0,0,0-.59.27,13.54,13.54,0,0,0-2.07,11.39l3.14,11.77a1.54,1.54,0,0,1,0,.74l-6.21,23.58a1.42,1.42,0,0,1-.74.92l-26.81,13.79a39.92,39.92,0,0,0-20.45,25.74L220.47,414.32A1.46,1.46,0,0,1,219.06,415.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M178.59,139.47c5.53-34.9-29.84-69.51-79-77.3S6.1,76.36.57,111.25s29.84,69.51,79,77.3q5.18.81,10.25,1.2L77.25,220.23a5,5,0,0,0,8.47,4.25l30.65-35.61C149.17,184,174.49,165.28,178.59,139.47Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "117.31 154.49 99.78 142.39 75.03 166.17 75.09 132.05 50.44 115.2 76.71 113.24 80.42 82.08 100.83 106.62 133.14 103 113.49 129.08 117.31 154.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M417,140c-9.29-29.51,10.22-61.93,43.57-72.42s67.9,4.93,77.18,34.44S527.55,164,494.2,174.44a71.74,71.74,0,0,1-7,1.82l4.26,13.54c1.28,4-2.37,7-5.29,4.3l-17.77-16.53C444.58,175.94,423.88,161.83,417,140Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "440.17 107.85 466.27 109.53 481.11 85.26 489.58 116.93 512.65 120.47 489.92 132.68 497.48 153.99 474.67 139.3 451.93 157.46 462.12 125.87 440.17 107.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M286.89,58.36s-37.36-43.2-3.07-28.65c11.26,4.78-2.39,10.92-2.39,10.92s4.44-17.74,17.4-20.47S298.83,42.33,286.89,58.36Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValeu);
export default __webpack_public_path__ + "static/media/valeu.4f207e036eb73bd48decf8e5ee96e6aa.svg";
export { ForwardRef as ReactComponent };